import React from 'react'

const TextArea = ({name,onChange}) => {
    
    return(
        <div className='container_inputs_mobile'>
        <label>{name}</label>
        <textarea aria-expanded="false" onChange={onChange} className='textArea_input_mobile'></textarea>

        </div>
    )
}

export default TextArea